import { useTranslation } from 'react-i18next';

import { ReportData } from '../types';
import { formatMeasureValue } from '../utils/format-measure';

interface ElementKpiCardProps {
  data: ReportData;
}

export const ElementKpiCard = ({ data }: ElementKpiCardProps) => {
  const { t } = useTranslation('authenticated.reports');
  const firstMeasure = data.measures[0];
  const firstRow = data.rows[0];

  if (!firstMeasure || !firstRow) {
    return (
      <div className="flex flex-col items-center justify-center py-4">
        <span className="text-3xl font-bold text-foreground">{t('common.emDash')}</span>
        <span className="mt-1 text-sm text-muted-foreground">{t('common.noData')}</span>
      </div>
    );
  }

  const value = firstRow.columns[firstMeasure.key];

  return (
    <div className="flex h-full flex-col items-center justify-center py-4">
      <span className="text-3xl font-bold tabular-nums text-foreground">
        {formatMeasureValue(value, firstMeasure.type, t('common.emDash'))}
      </span>
      <span className="mt-1 text-sm text-muted-foreground">{firstMeasure.label}</span>
    </div>
  );
};
